// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"903cb917","455":"27b23a10"}[chunkId] + ".chunk.js";
};